import { render, staticRenderFns } from "./MemberAvatar.vue?vue&type=template&id=ec595864&scoped=true"
import script from "./MemberAvatar.vue?vue&type=script&lang=js"
export * from "./MemberAvatar.vue?vue&type=script&lang=js"
import style0 from "./MemberAvatar.vue?vue&type=style&index=0&id=ec595864&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec595864",
  null
  
)

export default component.exports